/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
export const EnumHelper = (data: any = {}) => {
  return Object.keys(data).map((value) => ({
    id: data[value],
    name: value
      .toLowerCase()
      .replaceAll("_", " ")
      .replace(/\b[a-z]/g, (text) => text.toUpperCase()),
  }));
};
export const CourseSectionEnum = {
  PRE_TEST: 1,
  CONTENTS: 2,
  POST_TEST: 3,
  ATTACHMENTS: 4,
  RATING: 5,
  EVALUATION: 6,
  CERTIFICATE: 7,
};
export const CourseAssessmentTypeEnum = {
  PRE_TEST: 1,
  POST_TEST: 2,
};
export const CourseAssessmentQuestionTypeEnum = {
  SHORT_TEXT: 1,
  LONG_TEXT: 2,
  MULTIPLE_CHOICES: 3,
  CHECKBOX: 4,
  DROPDOWN: 5,
  FILE: 6,
  SCALE: 7,
};
export const CourseLevelEnum = {
  BEGINNER: 1,
  INTERMEDIATE: 2,
  ADVANCED: 3,
};
export const PaymentTypeEnum = {
  OVO: 1,
  DANA: 2,
  QRIS: 3,
  FREE: 4,
};
export const CourseTransactionStatusEnum = {
  PENDING: 1,
  REJECTED: 2,
  APPROVED: 3,
  EXPIRED: 4,
};
